export const WORKER_IDS = {
  UPLOAD_DATA: 'uploadData',
};
